module.exports = "https://www.gc-pro.gnp.com.mx/5479f15912dc71183cf7131ab6d1d6a9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon_autos.svg
// module id = 688
// module chunks = 0